/* ==========================================================================
   LOXERA – Interaktionen (vanilla JS, keine Abhängigkeiten, keine Tracker)
   Alle Komponenten werden über data-lx-* Attribute aktiviert.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function fmtEUR(n) { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Math.round(n)); }
  function fmtNum(n) { return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(Math.round(n)); }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }

  /* ---------- Typing helper ---------- */
  function typeInto(opts) {
    /* opts: {parts:[{el,text}], speed, onDone} – tippt Teile nacheinander */
    var total = opts.parts.reduce(function (s, p) { return s + p.text.length; }, 0);
    var n = 0;
    var timer = null;
    function render() {
      var left = n;
      opts.parts.forEach(function (p) {
        var take = clamp(left, 0, p.text.length);
        p.el.textContent = p.text.slice(0, take);
        left -= take;
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduce) { n = total; render(); if (opts.onDone) opts.onDone(); return; }
      n = 0; render();
      timer = setInterval(function () {
        n = Math.min(total, n + (opts.step || 2));
        render();
        if (opts.onProgress) opts.onProgress(n, total);
        if (n >= total) { stop(); if (opts.onDone) opts.onDone(); }
      }, opts.speed || 24);
    }
    return { start: start, stop: stop };
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.lx-reveal, .lx-stagger, .lx-chart');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var hdr = $('[data-lx-header]');
    if (!hdr) return;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      var solid = y > 24;
      hdr.classList.toggle('is-solid', solid);
      hdr.classList.toggle('is-top', !solid);
      var goingDown = y > lastY + 6;
      var goingUp = y < lastY - 6;
      if (y > 480 && goingDown && !doc.querySelector('.lx-mob.is-open') && !hdr.querySelector('.lx-nav__link[aria-expanded="true"]')) hdr.classList.add('is-hidden');
      else if (goingUp || y <= 480) hdr.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    update();

    /* Mega-Menüs */
    var triggers = $$('[data-lx-mega]', hdr);
    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = doc.getElementById(t.getAttribute('aria-controls'));
        if (p) p.classList.remove('is-open');
      });
    }
    triggers.forEach(function (t) {
      var panel = doc.getElementById(t.getAttribute('aria-controls'));
      var item = t.closest('.lx-nav__item');
      var hoverTimer = null;
      function open() { closeAll(t); t.setAttribute('aria-expanded', 'true'); if (panel) panel.classList.add('is-open'); }
      function close() { t.setAttribute('aria-expanded', 'false'); if (panel) panel.classList.remove('is-open'); }
      on(t, 'click', function () { t.getAttribute('aria-expanded') === 'true' ? close() : open(); });
      if (finePointer && item) {
        on(item, 'mouseenter', function () { clearTimeout(hoverTimer); open(); });
        on(item, 'mouseleave', function () { hoverTimer = setTimeout(close, 140); });
      }
      on(item, 'focusout', function (e) { if (item && !item.contains(e.relatedTarget)) close(); });
    });
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeMobile(); }
    });
    on(doc, 'click', function (e) { if (!hdr.contains(e.target)) closeAll(); });

    /* Mobiles Menü */
    var mob = $('[data-lx-mobile]');
    var burger = $('[data-lx-burger]');
    var lastFocus = null;
    function openMobile() { if (!mob) return; lastFocus = doc.activeElement; mob.classList.add('is-open'); burger && burger.setAttribute('aria-expanded', 'true'); doc.body.style.overflow = 'hidden'; var c = $('[data-lx-mobile-close]', mob); c && c.focus(); }
    function closeMobile() { if (!mob || !mob.classList.contains('is-open')) return; mob.classList.remove('is-open'); burger && burger.setAttribute('aria-expanded', 'false'); doc.body.style.overflow = ''; lastFocus && lastFocus.focus && lastFocus.focus(); }
    on(burger, 'click', openMobile);
    $$('[data-lx-mobile-close]').forEach(function (b) { on(b, 'click', closeMobile); });
    $$('[data-lx-mobile] a').forEach(function (a) { on(a, 'click', closeMobile); });
    $$('[data-lx-mob-acc]').forEach(function (b) {
      on(b, 'click', function () {
        var sub = doc.getElementById(b.getAttribute('aria-controls'));
        var o = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', o ? 'false' : 'true');
        if (sub) sub.classList.toggle('is-open', !o);
      });
    });
  }

  /* ---------- Hero: Maus-Spotlight ---------- */
  function initSpot() {
    var hero = $('[data-lx-spot]');
    var spot = hero && $('.lx-hero__spot', hero);
    if (!hero || !spot || reduce || !finePointer) return;
    on(hero, 'mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      spot.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      spot.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  }

  /* ---------- Hero: ChatGPT / Google Simulation ---------- */
  function initHeroSim() {
    $$('[data-lx-herosim]').forEach(function (sim) {
      var cfg = json($('[data-lx-json]', sim)) || {};
      var tabChat = $('[data-tab="chat"]', sim), tabG = $('[data-tab="google"]', sim);
      var pChat = $('[data-panel="chat"]', sim), pG = $('[data-panel="google"]', sim);
      var cited = $('.lx-cited', sim), caret = $('.lx-caret', sim), src = $('.lx-src', sim);
      var elPre = $('[data-pre]', sim), elName = $('[data-name]', sim), elPost = $('[data-post]', sim);
      var typer = null;
      function startTyping() {
        if (typer) typer.stop();
        cited.classList.remove('is-on'); src.classList.remove('is-on'); caret.style.display = '';
        typer = typeInto({
          parts: [{ el: elPre, text: cfg.pre || '' }, { el: elName, text: cfg.name || '' }, { el: elPost, text: cfg.post || '' }],
          speed: 24, step: 2,
          onDone: function () { caret.style.display = 'none'; src.classList.add('is-on'); cited.classList.add('is-on'); }
        });
        typer.start();
      }
      function show(which) {
        var chat = which === 'chat';
        tabChat.setAttribute('aria-selected', chat ? 'true' : 'false');
        tabG.setAttribute('aria-selected', chat ? 'false' : 'true');
        pChat.hidden = !chat; pG.hidden = chat;
        if (chat) startTyping(); else { if (typer) typer.stop(); cited.classList.remove('is-on'); }
      }
      on(tabChat, 'click', function () { if (tabChat.getAttribute('aria-selected') !== 'true') show('chat'); });
      on(tabG, 'click', function () { if (tabG.getAttribute('aria-selected') !== 'true') show('google'); });
      setTimeout(startTyping, 800);
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    $$('[data-lx-acc]').forEach(function (acc) {
      var items = $$('.lx-acc__item', acc);
      var single = acc.getAttribute('data-lx-acc') !== 'multi';
      items.forEach(function (it) {
        var btn = $('.lx-acc__btn', it);
        on(btn, 'click', function () {
          var open = it.classList.contains('is-open');
          if (single) items.forEach(function (o) { o.classList.remove('is-open'); var b = $('.lx-acc__btn', o); b && b.setAttribute('aria-expanded', 'false'); });
          it.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---------- Flip cards ---------- */
  function initFlip() {
    $$('.lx-flip__in').forEach(function (c) {
      on(c, 'click', function () {
        var f = c.classList.toggle('is-flipped');
        c.setAttribute('aria-pressed', f ? 'true' : 'false');
      });
    });
  }

  /* ---------- Tilt + Magnetic ---------- */
  function initTilt() {
    if (reduce || !finePointer) return;
    $$('.lx-tilt').forEach(function (c) {
      on(c, 'mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        c.style.setProperty('--px', (x * 100) + '%'); c.style.setProperty('--py', (y * 100) + '%');
        c.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 5).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 6).toFixed(2) + 'deg) translateY(-6px)';
      });
      on(c, 'mouseleave', function () { c.style.transform = ''; });
    });
    $$('[data-lx-magnet]').forEach(function (b) {
      on(b, 'mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.14).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.22).toFixed(1) + 'px)';
      });
      on(b, 'mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Prozess: Sticky-Storytelling ---------- */
  function initProcess() {
    $$('[data-lx-process]').forEach(function (wrap) {
      var steps = $$('.lx-step', wrap);
      var bar = $('.lx-steps__bar', wrap);
      var list = $('.lx-steps', wrap);
      if (!steps.length) return;
      function update() {
        var mid = window.innerHeight * 0.5;
        var active = 0;
        steps.forEach(function (s, i) { if (s.getBoundingClientRect().top < mid) active = i; });
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i <= active); });
        if (bar && list) {
          var lr = list.getBoundingClientRect();
          var p = clamp((mid - lr.top) / lr.height, 0, 1);
          bar.style.setProperty('--prog', (p * 100).toFixed(1) + '%');
        }
      }
      on(window, 'scroll', update, { passive: true }); on(window, 'resize', update); update();
    });
  }

  /* ---------- Preis-Umschalter ---------- */
  function initPricing() {
    $$('[data-lx-pricing]').forEach(function (sec) {
      var data = json($('[data-lx-json]', sec)) || {};
      var segs = $$('[data-plan]', sec);
      var cards = $$('.lx-price', sec);
      var CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
      function apply(key) {
        var plan = data[key]; if (!plan) return;
        cards.forEach(function (c, i) {
          var d = plan[i]; if (!d) return;
          c.querySelector('[data-amt]').textContent = d.price;
          c.querySelector('[data-per]').textContent = d.period;
          c.querySelector('[data-meta]').textContent = d.meta;
          c.querySelector('[data-feats]').innerHTML = d.features.map(function (f) { return '<div class="lx-feat">' + CHECK + '<span>' + esc(f) + '</span></div>'; }).join('');
        });
      }
      segs.forEach(function (s) {
        on(s, 'click', function () {
          var k = s.getAttribute('data-plan');
          segs.forEach(function (o) { o.setAttribute('aria-selected', o === s ? 'true' : 'false'); });
          var swaps = $$('[data-feats],[data-amt]', sec);
          if (reduce) { apply(k); return; }
          swaps.forEach(function (el) { el.classList.add('lx-swap', 'is-out'); });
          setTimeout(function () { apply(k); swaps.forEach(function (el) { el.classList.remove('is-out'); }); }, 220);
        });
      });
    });
  }

  /* ---------- Branchen-Demo ---------- */
  function initIndustries() {
    $$('[data-lx-ind]').forEach(function (sec) {
      var data = json($('[data-lx-json]', sec)) || [];
      var btns = $$('[data-ind]', sec);
      var q = $('[data-ind-q]', sec), a = $('[data-ind-a]', sec), out = $('[data-ind-out]', sec), car = $('[data-ind-caret]', sec), go = $('[data-ind-go]', sec);
      var typer = null;
      function sel(i) {
        btns.forEach(function (b, j) { var o = j === i; b.classList.toggle('is-on', o); b.setAttribute('aria-selected', o ? 'true' : 'false'); });
        var d = data[i]; if (!d) return;
        a.textContent = d.text;
        if (go) { go.setAttribute('href', d.url || '#'); }
        if (typer) typer.stop();
        out.classList.remove('is-in'); car.style.display = '';
        typer = typeInto({ parts: [{ el: q, text: d.q }], speed: 22, step: 2, onDone: function () { car.style.display = 'none'; out.classList.add('is-in'); } });
        typer.start();
      }
      btns.forEach(function (b, j) { on(b, 'click', function () { if (!b.classList.contains('is-on')) sel(j); }); });
      if (btns.length) sel(0);
    });
  }

  /* ---------- Range-Fill ---------- */
  function fillRange(r) { var min = +r.min || 0, max = +r.max || 100; r.style.setProperty('--fill', ((r.value - min) / (max - min) * 100) + '%'); }

  /* ---------- ROI-Rechner ---------- */
  function initRoi() {
    $$('[data-lx-roi]').forEach(function (sec) {
      var pkg = +sec.getAttribute('data-package') || 2490;
      var ids = ['searches', 'now', 'gain', 'req', 'close', 'value'];
      var R = {}; ids.forEach(function (id) { R[id] = $('[data-r="' + id + '"]', sec); });
      var outYear = $('[data-o="year"]', sec), outMonth = $('[data-o="month"]', sec), outVis = $('[data-o="visitors"]', sec), outJobs = $('[data-o="jobs"]', sec), outBE = $('[data-o="be"]', sec);
      var shown = 0, raf = null;
      function labels() {
        var f = { searches: fmtNum, now: function (v) { return v + ' %'; }, gain: function (v) { return '+' + v + ' Pkt.'; }, req: function (v) { return v + ' %'; }, close: function (v) { return v + ' %'; }, value: fmtEUR };
        ids.forEach(function (id) { var o = $('[data-v="' + id + '"]', sec); if (o && R[id]) o.textContent = f[id](+R[id].value); fillRange(R[id]); });
      }
      function calc() {
        var s = +R.searches.value, now = +R.now.value, gain = +R.gain.value, req = +R.req.value / 100, cl = +R.close.value / 100, val = +R.value.value;
        var extra = s * (gain / 100);
        var inq = extra * req; var jobs = inq * cl; var month = jobs * val; var year = month * 12;
        outVis.textContent = fmtNum(extra); outJobs.textContent = (Math.round(jobs * 10) / 10).toLocaleString('de-DE');
        outMonth.textContent = fmtEUR(month);
        outBE.textContent = jobs > 0 ? (Math.ceil(pkg / val) <= 1 ? 'ein einziger zusätzlicher Auftrag' : 'ca. ' + Math.ceil(pkg / val) + ' zusätzliche Aufträge') : '–';
        animateTo(year);
      }
      function animateTo(target) {
        if (raf) cancelAnimationFrame(raf);
        if (reduce) { outYear.textContent = fmtEUR(target); shown = target; return; }
        var start = shown, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = clamp((ts - t0) / 600, 0, 1), e = 1 - Math.pow(1 - p, 3);
          shown = start + (target - start) * e; outYear.textContent = fmtEUR(shown);
          if (p < 1) raf = requestAnimationFrame(step);
        }
        raf = requestAnimationFrame(step);
      }
      ids.forEach(function (id) { on(R[id], 'input', function () { labels(); calc(); }); });
      labels(); calc();
    });
  }

  /* ---------- KI-Antwort-Simulator ---------- */
  function initAiSim() {
    $$('[data-lx-aisim]').forEach(function (sec) {
      var data = json($('[data-lx-json]', sec)) || [];
      var selB = $('[data-s="branch"]', sec), inCity = $('[data-s="city"]', sec), inName = $('[data-s="name"]', sec), go = $('[data-s="go"]', sec);
      var qEl = $('[data-s="q"]', sec), badEl = $('[data-s="bad"]', sec), goodEl = $('[data-s="good"]', sec), srcEl = $('[data-s="src"]', sec), outWrap = $('[data-s="out"]', sec), err = $('[data-s="err"]', sec);
      var typers = [];
      data.forEach(function (d, i) { var o = doc.createElement('option'); o.value = i; o.textContent = d.label; selB.appendChild(o); });
      function fill(t, c, n) { return t.replace(/\{city\}/g, c).replace(/\{name\}/g, n); }
      function domainOf(name) {
        var s = name.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        return (s || 'ihre-firma') + '.de';
      }
      function run() {
        var d = data[+selB.value]; if (!d) return;
        var city = inCity.value.trim(), name = inName.value.trim();
        if (!city || !name) { err.textContent = 'Bitte Stadt und Firmennamen eintragen. Es sind nur Beispieleingaben, nichts wird gespeichert.'; (!city ? inCity : inName).focus(); return; }
        if (city.length > 40 || name.length > 60) { err.textContent = 'Bitte kürzere Eingaben verwenden.'; return; }
        err.textContent = '';
        typers.forEach(function (t) { t.stop(); }); typers = [];
        outWrap.hidden = false; var idle = $('[data-s="idle"]', sec); if (idle) idle.hidden = true; srcEl.classList.remove('is-on'); badEl.textContent = ''; goodEl.textContent = '';
        qEl.textContent = fill(d.q, city, name);
        srcEl.textContent = domainOf(name);
        var bad = fill(d.bad, city, name), good = fill(d.good, city, name);
        var t1 = typeInto({ parts: [{ el: badEl, text: bad }], speed: 16, step: 2 });
        var t2 = typeInto({ parts: [{ el: goodEl, text: good }], speed: 16, step: 2, onDone: function () { srcEl.classList.add('is-on'); } });
        typers.push(t1, t2);
        t1.start(); setTimeout(function () { t2.start(); }, reduce ? 0 : 500);
      }
      on(go, 'click', run);
      [inCity, inName].forEach(function (i) { on(i, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } }); });
    });
  }

  /* ---------- Echter PageSpeed-/SEO-Check ---------- */
  function initCheck() {
    $$('[data-lx-check]').forEach(function (sec) {
      var urlIn = $('[data-c="url"]', sec), btn = $('[data-c="btn"]', sec), consent = $('[data-c="consent"]', sec), err = $('[data-c="err"]', sec);
      var scoresWrap = $('[data-c="scores"]', sec), list = $('[data-c="list"]', sec), fine = $('[data-c="fine"]', sec), cta = $('[data-c="cta"]', sec), status = $('[data-c="status"]', sec);
      var apiKey = sec.getAttribute('data-key') || '', proxy = sec.getAttribute('data-proxy') || '', ctaBase = sec.getAttribute('data-cta') || '';
      var busy = false, C = 2 * Math.PI * 34;

      function normalize(raw) {
        var v = raw.trim();
        if (!v || /\s/.test(v)) return null;
        if (!/^https?:\/\//i.test(v)) v = 'https://' + v;
        var u; try { u = new URL(v); } catch (e) { return null; }
        if (!/^https?:$/.test(u.protocol)) return null;
        var h = u.hostname.toLowerCase();
        if (h.indexOf('.') < 0 || /^(localhost|127\.|10\.|192\.168\.|169\.254\.|0\.)/.test(h) || /\.(local|internal|test)$/.test(h)) return null;
        return u.origin + (u.pathname === '/' ? '/' : u.pathname);
      }
      function ring(label, pct, color) {
        var s = Math.round(pct * 100);
        var off = (C * (1 - pct)).toFixed(1);
        return '<div class="lx-score"><svg viewBox="0 0 84 84" aria-hidden="true"><circle cx="42" cy="42" r="34" stroke="rgba(247,243,234,.1)" stroke-width="5" fill="none"/><circle class="arc" cx="42" cy="42" r="34" stroke="' + color + '" stroke-width="5" fill="none" stroke-linecap="round" stroke-dasharray="' + C.toFixed(1) + '" stroke-dashoffset="' + C.toFixed(1) + '" data-off="' + off + '" transform="rotate(-90 42 42)"/></svg><div class="lx-score__num">' + s + '</div><div class="lx-score__lbl">' + label + '</div></div>';
      }
      function col(p) { return p >= 0.9 ? '#7FB58F' : p >= 0.5 ? '#C9A65E' : '#D9826B'; }
      function dot(p) { return p == null ? 'lx-mid' : p >= 0.9 ? 'lx-ok' : p >= 0.5 ? 'lx-mid' : 'lx-bad'; }
      function row(txt, cls, delay) { var d = doc.createElement('div'); d.className = 'lx-checkrow'; d.style.animationDelay = delay + 's'; var i = doc.createElement('i'); i.className = cls; var s = doc.createElement('span'); s.textContent = txt; d.appendChild(i); d.appendChild(s); return d; }
      function setBusy(b) { busy = b; btn.disabled = b; btn.innerHTML = b ? '<span class="lx-loader"></span> Analysiere …' : 'Jetzt prüfen'; }

      function run() {
        if (busy) return;
        err.textContent = '';
        var url = normalize(urlIn.value);
        if (!url) { err.textContent = 'Bitte eine gültige Domain eingeben, z. B. www.ihre-firma.de.'; urlIn.focus(); return; }
        if (!consent.checked) { err.textContent = 'Bitte stimmen Sie der Übermittlung an Google zu, sonst kann der Check nicht laufen.'; consent.focus(); return; }
        setBusy(true); scoresWrap.innerHTML = ''; list.innerHTML = ''; fine.hidden = true; cta.hidden = true;
        status.textContent = 'Google PageSpeed analysiert Ihre Seite. Das dauert 15 bis 40 Sekunden …';
        var cats = ['performance', 'seo', 'accessibility', 'best-practices'].map(function (c) { return 'category=' + c; }).join('&');
        var api = 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed?strategy=mobile&locale=de&' + cats + '&url=' + encodeURIComponent(url) + (apiKey ? '&key=' + encodeURIComponent(apiKey) : '');
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        var to = setTimeout(function () { ctrl && ctrl.abort(); }, 90000);
        var extra = proxy ? fetch(proxy + (proxy.indexOf('?') > -1 ? '&' : '?') + 'url=' + encodeURIComponent(url)).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
        fetch(api, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
          if (r.status === 429) throw new Error('quota');
          if (!r.ok) throw new Error('http' + r.status);
          return r.json();
        }).then(function (res) { return extra.then(function (ex) { render(res, ex, url); }); })
          .catch(function (e) {
            status.textContent = '';
            err.textContent = e.message === 'quota' ? 'Gerade sind zu viele Prüfungen aktiv. Bitte versuchen Sie es in einigen Minuten erneut oder buchen Sie direkt Ihr Erstgespräch.'
              : e.name === 'AbortError' ? 'Die Analyse hat zu lange gedauert. Bitte versuchen Sie es erneut.'
              : 'Die Seite konnte nicht analysiert werden. Ist die Adresse öffentlich erreichbar und richtig geschrieben?';
          }).then(function () { clearTimeout(to); setBusy(false); });
      }

      function render(res, ex, url) {
        var lh = res && res.lighthouseResult; if (!lh) { err.textContent = 'Keine Auswertung erhalten.'; status.textContent = ''; return; }
        var c = lh.categories || {}, a = lh.audits || {};
        var items = [['Geschwindigkeit', c.performance], ['SEO-Technik', c.seo], ['Barrierefreiheit', c.accessibility], ['Best Practices', c['best-practices']]];
        scoresWrap.innerHTML = items.map(function (it) { var s = it[1] ? it[1].score : 0; return ring(it[0], s, col(s)); }).join('');
        requestAnimationFrame(function () { requestAnimationFrame(function () { $$('.arc', scoresWrap).forEach(function (el) { el.style.strokeDashoffset = el.getAttribute('data-off'); }); }); });
        status.textContent = 'Auswertung für ' + url + ' (mobil)';
        var checks = [
          ['document-title', 'Seitentitel vorhanden'], ['meta-description', 'Meta-Beschreibung vorhanden'], ['viewport', 'Mobil-Darstellung (Viewport) korrekt'],
          ['is-crawlable', 'Seite ist für Suchmaschinen crawlbar'], ['canonical', 'Canonical-Link gültig'], ['image-alt', 'Bilder mit Alternativtext'], ['http-status-code', 'Seite antwortet fehlerfrei']
        ];
        var d = 0.1;
        checks.forEach(function (k) { var au = a[k[0]]; if (au && au.score != null) { list.appendChild(row(k[1] + (au.score >= 0.9 ? '' : ' – Verbesserung nötig'), dot(au.score), d)); d += 0.1; } });
        var lcp = a['largest-contentful-paint'];
        if (lcp && lcp.displayValue) list.appendChild(row('Größtes Element geladen nach ' + lcp.displayValue + ' (Ziel: unter 2,5 s)', dot(lcp.score), d));
        if (ex && typeof ex === 'object') {
          d += 0.1;
          if ('schema' in ex) list.appendChild(row(ex.schema ? 'Strukturierte Daten (Schema-Markup) gefunden' : 'Keine strukturierten Daten (Schema-Markup) gefunden', ex.schema ? 'lx-ok' : 'lx-bad', d));
          if ('llms' in ex) list.appendChild(row(ex.llms ? 'llms.txt vorhanden' : 'Keine llms.txt für KI-Crawler', ex.llms ? 'lx-ok' : 'lx-bad', d + 0.1));
        } else {
          list.appendChild(row('Schema-Markup und llms.txt prüfen wir im Erstgespräch per Hand für Sie mit.', 'lx-mid', d + 0.1));
        }
        fine.hidden = false;
        var host = ''; try { host = new URL(url).hostname; } catch (e) { /* ignore */ }
        if (ctaBase) { cta.setAttribute('href', ctaBase + (ctaBase.indexOf('?') > -1 ? '&' : '?') + 'domain=' + encodeURIComponent(host) + '#kontakt'); cta.hidden = false; }
      }
      on(btn, 'click', run);
      on(urlIn, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    });
  }

  /* ---------- Kontaktformular ---------- */
  function initForms() {
    $$('#lx-contact-form, [data-lx-form]').forEach(function (form) {
      var domain = new URLSearchParams(window.location.search).get('domain');
      var msg = $('textarea', form);
      if (domain && msg && !msg.value) { msg.value = 'Bitte prüfen Sie meine Website: ' + domain.replace(/[^a-zA-Z0-9.\-]/g, ''); }
      function setErr(el, text) {
        var holder = $('[data-err="' + el.name.replace(/[\[\]]/g, '-') + '"]', form) || el.parentNode.querySelector('.lx-ferr');
        if (holder) holder.textContent = text || '';
        el.setAttribute('aria-invalid', text ? 'true' : 'false');
      }
      on(form, 'submit', function (e) {
        var ok = true, first = null;
        $$('[data-req]', form).forEach(function (el) {
          var v = (el.type === 'checkbox') ? el.checked : el.value.trim();
          var bad = !v;
          if (!bad && el.type === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value);
          setErr(el, bad ? (el.getAttribute('data-msg') || 'Bitte ausfüllen.') : '');
          if (bad) { ok = false; if (!first) first = el; }
        });
        if (!ok) { e.preventDefault(); first && first.focus(); return; }
        var b = $('button[type="submit"]', form); if (b) { b.disabled = true; b.textContent = 'Wird gesendet …'; }
      });
    });
  }

  /* ---------- Cal.com / externe Einbettungen erst nach Einwilligung ---------- */
  function initEmbeds() {
    $$('[data-lx-embed]').forEach(function (box) {
      var btn = $('[data-embed-load]', box), host = $('[data-embed-host]', box), src = box.getAttribute('data-src');
      function load() {
        if (!src) return;
        var f = doc.createElement('iframe'); f.src = src; f.loading = 'lazy'; f.title = box.getAttribute('data-title') || 'Terminbuchung';
        f.setAttribute('allow', 'payment'); host.innerHTML = ''; host.appendChild(f);
        lsSet('lx-ext', '1');
      }
      on(btn, 'click', load);
      if (lsGet('lx-ext') === '1') load();
    });
  }

  /* ---------- Cookie-Einstellungen: öffnet das Shopify-Consent-Banner ---------- */
  function initConsent() {
    $$('[data-lx-consent-open]').forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        try {
          if (window.Shopify && window.Shopify.loadFeatures) {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
              var cp = window.Shopify.customerPrivacy;
              if (!err && cp && typeof cp.showPreferences === 'function') cp.showPreferences();
            });
          }
        } catch (er) { /* ignore */ }
      });
    });
  }

  /* ---------- Artikel: Lesefortschritt + Inhaltsverzeichnis ---------- */
  function initArticle() {
    var prose = $('[data-lx-prose]');
    var bar = $('.lx-readbar');
    if (bar && prose) {
      on(window, 'scroll', function () {
        var r = prose.getBoundingClientRect(), h = r.height - window.innerHeight * 0.6;
        root.style.setProperty('--read', clamp((-r.top + window.innerHeight * 0.2) / Math.max(h, 1), 0, 1).toFixed(3));
      }, { passive: true });
    }
    var toc = $('[data-lx-toc]');
    if (toc && prose) {
      var heads = $$('h2', prose);
      if (heads.length < 2) { toc.hidden = true; return; }
      heads.forEach(function (h, i) { if (!h.id) h.id = 'abschnitt-' + (i + 1); var a = doc.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; toc.appendChild(a); });
      if ('IntersectionObserver' in window) {
        var links = $$('a', toc);
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + en.target.id); }); } }); }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }
  }

  /* ---------- Jahr im Footer ---------- */
  function initYear() { $$('[data-lx-year]').forEach(function (e) { e.textContent = new Date().getFullYear(); }); }

  function boot() {
    initReveal(); initHeader(); initSpot(); initHeroSim(); initAccordions(); initFlip(); initTilt(); initProcess();
    initPricing(); initIndustries(); initRoi(); initAiSim(); initCheck(); initForms(); initEmbeds(); initConsent(); initArticle(); initYear();
    $$('.lx-range').forEach(fillRange);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme-Editor: Sections neu initialisieren */
  doc.addEventListener('shopify:section:load', function () { boot(); });
})();
